module.exports = __webpack_public_path__ + "static/banner-dentists-ccaa61ee496277332f34032a8d81ed81.png";